export default __webpack_public_path__ + "4a9aa326cf064d5dfa46b4e919be7100.ttf";